import React, { useEffect, useRef } from "react";
import { FaArrowLeft } from "react-icons/fa";

import "./checkout-theme.css";

/*
 * ນັບຈຳນວນ sheet ທີ່ເປີດຢູ່ ແທນທີ່ຈະໃຫ້ແຕ່ລະອັນຈື່ຄ່າເກົ່າຂອງຕົນເອງ
 *
 * sheet ຊ້ອນກັນໄດ້ (ລາຍການທີ່ຢູ່ → ຟອມເພີ່ມທີ່ຢູ່). ອັນນອກຈື່ "" ອັນໃນຈື່ "hidden"
 * ຕອນປິດເທື່ອລະອັນບໍ່ເປັນຫຍັງ ແຕ່ "ພິມທີ່ຢູ່ເອງ" ປິດທັງສອງພ້ອມກັນ ຕົວທີ່ຄືນຄ່າສຸດທ້າຍ
 * ອາດເປັນອັນທີ່ຈື່ "hidden" → body ຄ້າງ hidden ແລ້ວໜ້າ checkout ເລື່ອນບໍ່ໄດ້
 *
 * ນັບແບບນີ້ຜົນຈະຄືກັນບໍ່ວ່າ React ຈະ unmount ຮຽງລຳດັບໃດ
 */
let openSheetCount = 0;
let overflowBeforeLock = "";

const lockBodyScroll = () => {
  if (openSheetCount === 0) {
    overflowBeforeLock = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }
  openSheetCount += 1;
};

const unlockBodyScroll = () => {
  openSheetCount = Math.max(0, openSheetCount - 1);
  if (openSheetCount === 0) document.body.style.overflow = overflowBeforeLock;
};

// ໜ້າເຕັມຈໍສຳລັບຟອມທີ່ຢູ່ — ໃຊ້ overlay ແທນ route ໃໝ່ ເພື່ອບໍ່ໃຫ້ເສຍ state ທີ່ຄ້າງຢູ່
// ໃນໜ້າ checkout (ຂົນສົ່ງທີ່ເລືອກ, ເບີທີ່ຄົ້ນ, ສະລິບທີ່ອັບໂຫຼດແລ້ວ)
function AddressSheet({ open, title, onClose, children }) {
  const bodyRef = useRef(null);
  const lastFocusedRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    // ຈື່ວ່າກົດມາຈາກປຸ່ມໃດ ຈະໄດ້ສົ່ງ focus ກັບຄືນຕອນປິດ
    lastFocusedRef.current = document.activeElement;
    if (bodyRef.current) bodyRef.current.focus();

    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);

    // ລ໋ອກການເລື່ອນຂອງໜ້າຫຼັງ ບໍ່ດັ່ງນັ້ນຈະເລື່ອນສອງຊັ້ນພ້ອມກັນ
    lockBodyScroll();

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      unlockBodyScroll();
      const last = lastFocusedRef.current;
      if (last && typeof last.focus === "function") last.focus();
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="cf-sheet" role="dialog" aria-modal="true" aria-label={title}>
      <header className="cf-sheet__header">
        <button type="button" className="cf-sheet__back" onClick={onClose} aria-label="ກັບຄືນ">
          <FaArrowLeft aria-hidden="true" />
        </button>
        <h2 className="cf-sheet__title">{title}</h2>
      </header>
      <div className="cf-sheet__body" ref={bodyRef} tabIndex={-1}>
        {children}
      </div>
    </div>
  );
}

export default AddressSheet;
